import { makeLocalStorage } from '@/main/factories/cache'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { i18nTranslationHelper } from './helpers'

import enTranslations from './locales/en.json'
import esTranslations from './locales/es.json'
import ptBrTranslations from './locales/pt.json'

const localCache = makeLocalStorage()

const resourcesI18n = {
  pt: { translation: ptBrTranslations },
  es: { translation: esTranslations },
  en: { translation: enTranslations }
}

// const { VITE_APP_ENV: APP_ENV } = import.meta.env

i18n
  .use(
    new LanguageDetector(null, {
      lookupLocalStorage: localCache.KEYS.APP_LANGUAGE
    })
  )
  .use(initReactI18next)
  .init({
    resources: resourcesI18n,
    debug: false,
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false
    }
  })

i18nTranslationHelper.init(i18n)

export default i18n
export { i18nTranslationHelper }
